import { memo } from 'react';
import styled from 'styled-components';

import Text from '../text';

export type ErrorProps = {
  data?: { message: string }[];
};

function Error({ data }: ErrorProps) {
  return (
    <div>
      {data &&
        data.map((item, idx) => (
          <ErrorWrapper key={idx}>
            <Text type="mode2" className="error" key={idx}>
              {item.message}
            </Text>
          </ErrorWrapper>
        ))}
    </div>
  );
}

const ErrorWrapper = styled.div`
  .error {
    background-color: rgba(255, 0, 0, 0.1);
    border: 1px solid ${({ theme }) => theme.colors.red};
    margin-top: 24px;
    padding: 8px;
    color: ${({ theme }) => theme.colors.red};
    text-align: center;
  }
`;

export default memo(Error);
